import {API, Setup} from '../../Services';


async function BlogDetail_api(eventId){
    let mallId= localStorage.getItem('mallId');
    const token = localStorage.getItem('token');
    return API.get(`/malls/${mallId?mallId:Setup.default_malls}/blog_posts/${eventId}`,{
        params:{post_type:"blog"},
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}


export {BlogDetail_api};
